import React from 'react'
import { RouteMatch, RouteObject } from 'react-router/lib/router'

import ShellView from '@probatix/myprobatix/core/shell'

import NotFoundPage from '@probatix/myprobatix/modules/Special/NotFoundPage'

import AuthorizationRouting from '@probatix/myprobatix/modules/Authorization/Authorization.routing'
import DashboardRouting from '@probatix/myprobatix/modules/DashboardPage/Dashboard.routing'
import CheckoutRouting from '@probatix/myprobatix/modules/Checkout/Checkout.routing'
import SpecialRouting from '@probatix/myprobatix/modules/Special/Special.routing'
import GuestRouting from '@probatix/myprobatix/modules/Guest/Guest.routing'
import Redirect from '@probatix/myprobatix/modules/Special/Redirect'

interface CustomRouteObject extends RouteObject {
  public?: boolean
}

export interface Route extends RouteMatch {
  route: CustomRouteObject
}

export default [
  {
    children: [
      ...AuthorizationRouting,
      ...CheckoutRouting,
      ...DashboardRouting,
      ...SpecialRouting,
      ...GuestRouting,
      {
        element: <NotFoundPage />,
        path: '*',
      },
    ],
    element: <ShellView />,
    path: ':locale',
  },
  {
    element: <Redirect />,
    path: '*',
  },
]

